<script setup>
import GameCard from './GameCard.vue';

defineProps({
  title: {
    type: String,
    required: true
  },
  games: {
    type: Array,
    required: true
  },
  category: {
    type: String,
    default: ''
  }
});
</script>

<template>
  <section class="game-collection">
    <div class="section-title">
      {{ title }}
      <router-link v-if="category" :to="`/category/${category}`" class="view-more">
        View more
      </router-link>
    </div>
    <div class="game-scroll">
      <div v-for="game in games" :key="game.id" class="game-card-wrapper">
        <GameCard :game="game" :isOriginal="category === 'originals'" />
      </div>
    </div>
  </section>
</template>

<style scoped>
.game-collection {
  margin-bottom: 2rem;
}

.game-scroll {
  display: flex;
  overflow-x: auto;
  gap: 1rem;
  padding-bottom: 1rem;
  scrollbar-width: thin;
}

.game-scroll::-webkit-scrollbar {
  height: 8px;
}

.game-card-wrapper {
  flex: 0 0 auto;
  width: 200px;
  
  @media (min-width: 576px) {
    width: 220px;
  }
  
  @media (min-width: 992px) {
    width: 250px;
  }
}
</style>